export default __webpack_public_path__ + "ie.jpg";